<template>
  <div id="app" v-cloak>

    <component :is="activeView" />
  </div>
</template>

<script>
  import SpinWheel from "@/components/SpinTheWheel";
  import TheNavbar from "@/components/TheNavbar";
  import TicTacToe from "@/components/TicTacToe";
  import one_to_50 from "@/components/1to50";
  import Match from "@/views/Match";
  // eslint-disable-next-line no-unused-vars
  import axios from "axios";
  export default {
    components: {
      SpinWheel,
      TheNavbar,
      TicTacToe,
      Match,
      one_to_50
    },
    mounted() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      this.$store.commit('matchSlug',params.get("trivia_id"));
      // this.$store.commit('setUserId',params.get("user_id"));
      this.$store.commit('isp',params.get("isp")==='true');
      this.$store.commit('showPodium',params.get("results"));
      this.$store.commit('showGameNightResults',params.get("leaderboard"));
      this.$store.commit('showEasterTriviaResults',params.get("EasterTrivia"));
      // this.$store.commit('setCurrentPlayer',{'team_id':params.get("team_id"),'team_name':params.get('team_name'),'name':params.get("nickname"),'phone':params.get("phone"),'id':params.get("pid")});
      // this.$store.commit('setCurrentTeam',{'team_id':params.get("team_id"),'team_name':params.get('team_name')});
      // this.$store.dispatch("client/startListener");

      this.$store.dispatch("viewGame", {'trivia_id':params.get("trivia_id"),'isp':params.get("isp")});
      // let elem = document.documentElement;

      /* View in fullscreen */

        // if (elem.requestFullscreen) {
        //   elem.requestFullscreen();
        // } else if (elem.webkitRequestFullscreen) { /* Safari */
        //   elem.webkitRequestFullscreen();
        // } else if (elem.msRequestFullscreen) { /* IE11 */
        //   elem.msRequestFullscreen();
        // }

    },
    computed: {
      activeView() {
        //return () => import("@/components/1to50");
        // Get status of the Match
        //const isOnBreak = this.$store.state.isOnBreak;
        //if(isOnBreak)
        //return () => import("@/components/MysteryBoxes");

        return () => import("@/views/Match");
      }
    },
    destroyed() {
      this.$store.dispatch("client/stopListener");
      this.$store.dispatch("leaveGame");
    }
  };
</script>

<style>
#app{
width: 100%;
}
</style>
